import { render, staticRenderFns } from "./ContratoList.vue?vue&type=template&id=4b56682c&scoped=true"
import script from "./ContratoList.vue?vue&type=script&lang=js"
export * from "./ContratoList.vue?vue&type=script&lang=js"
import style0 from "./ContratoList.vue?vue&type=style&index=0&id=4b56682c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b56682c",
  null
  
)

export default component.exports